// import {} from '../mutation-types';
const state = {

};
const getters = {}
// 方法调用逻辑
const actions = {
  //保存课程封面
  changeCover({commit, state}, data){

  },
};
// 逻辑代码
const mutations = {


};
export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/js/store/modules/outline.js